import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";
import {simpleListHeader_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/simpleListHeader_template";
import {filterDropdown_template} from "../../../common/js/vnKnockoutJsTemplates/filterDropdown_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterSingleDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;


export class articleRevenue_template extends vnTemplate{

    protected brandsFilter : filterDropdown_template;
    protected topPerformingArticleBrandSegmentsFilter : multipleSelector_template;
    protected postInitiativesFilter : multipleSelector_template;
    protected postPaymentCategorySystemFilter: multipleSelector_template
    protected postIntentsFilter : multipleSelector_template;
    protected postContentTypesFilter : multipleSelector_template;
    protected networkCategoriesFilter : multipleSelector_template;
    protected primaryCategoriesFilter: filterMultipleAutoComplete_template;
    protected primaryTagsFilter: filterMultipleAutoComplete_template;

    protected tagTypesFilter : filterMultipleAutoComplete_template;
    protected srEditorsFilter: filterMultipleAutoComplete_template;
    protected jrEditorsFilter: filterMultipleAutoComplete_template;
    protected authorsFilter: filterMultipleAutoComplete_template;
    protected ideatorsFilter: filterMultipleAutoComplete_template;
    protected brandSafetyFilter : multipleSelector_template;

    protected datesFilter: filterDate_template;
    protected dateFilter: filterDate_template;
    protected validationsList: validationsList_template;
    protected presetFilter: presetFilter_template;
    protected exportDataCsv: exportDataCsv;
    protected keywordFilter: filterSimple_template;
    protected resultsInfo: resultsInfo_template;
    
    protected pagination: pagination_template;
    protected headers: simpleListHeader_template;
    protected articlePerformanceHeaders: simpleListHeader_template;

    protected topPerformingArticleBrandsFilter: multipleSelector_template;
    protected countriesFilter: filterDropdown_template;
    protected topPerformingArticleDeviceFilter: multipleSelector_template;
    protected topPerformingArticlePremiumFilter: filterDropdown_template;
    protected topPerformingArticlePrimaryCategoriesFilter: filterMultipleAutoComplete_template;
    protected topPerformingArticlePostContentTypesFilter : multipleSelector_template
    protected topPerformingArticlePrimaryTagsFilter: filterMultipleAutoComplete_template;
    protected topPerformingArticleReportLimitFilter: filterDropdown_template;
    protected tagsFilter : filterMultipleAutoComplete_template;



    public minSessions;

    readonly publishStatus = [
        { "id": "", "name": "all"},
        { "id": "1", "name": "publish"},
        { "id": "2", "name": "republish"}
    ];

    readonly articleTypes : Array<{id : string, name : string}> = [
        {"id": "all", "name": "All"},
        {"id": "regular", "name": "Regular"},
        {"id": "video", "name": "Video"},
        {"id": "thread", "name": "Thread"},
        {"id": "db", "name": "DB"},
    ];

    readonly brandSafety : Array<{id : string, name : string}> = [
        {"id": "unknown", "name": "unknown"},
        {"id": "safe", "name": "Safe"},
        {"id": "partialUnsafe", "name": "Partial Unsafe"},
        {"id": "unsafe", "name": "Unsafe"},
    ];

    protected getTemplateHtml(): string{

        return  /*html*/`       
                <div class="sub-header w-justify">

                    ${this.presetFilter.getHtmlBuild()}


                    <div class="w-left">
                        <!--
                        <div data-bind="visible: viewModeSelected() == 'articleSv'">
                            <label class="form-label" for="" >Brand</label>
                            ${this.brandsFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'articleSv'">
                            ${this.postInitiativesFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'articleSv'">
                            ${this.postIntentsFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'articleSv'">
                            ${this.postContentTypesFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'articleSv'">
                            ${this.networkCategoriesFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'articleSv'">
                            ${this.primaryCategoriesFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'articleSv'">
                            ${this.primaryTagsFilter.getHtmlBuild()}
                        </div>

                        <div class="dropdown select-single" data-bind="visible: viewModeSelected() == 'articleSv'">
                            <label class="form-label" for="">Publishing type</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: publishStatusSelectedText"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: publishStatus">
                                        <input type="radio" data-bind="checked : $parent.publishStatusSelected, value: id,  attr: { 'id': 'pub_status_' + id, 'name' : 'pub_status_' + id }, event:{ change: $parent.onPublishStatusChange}">
                                        <label class="form-label" data-bind="attr: {for : 'pub_status_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="w-spec-search icon i-article-a" data-bind="visible: viewModeSelected() == 'articleSv'">
                            <input placeholder="Min Sessions" class="input-text" type="number" data-bind="value: minSessions, event:{ keyup: onMinSessionsChange }, valueUpdate: 'afterkeydown', attr:{id: 'min_sessions'}, css: 'input-text'" />
                            <button data-bind="event: { click: onClearMinSessions }, css: { 'is-showing' : minSessions }" class="close-btn icon i-x-after" id="close-btn" type="button"></button>
                        </div>
                        -->

                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.topPerformingArticleBrandsFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.topPerformingArticleBrandSegmentsFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.postInitiativesFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.postIntentsFilter.getHtmlBuild()}
                        </div>
                        
                        <!--
                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            <label class="form-label" for="" >Countries</label>
                            ${this.countriesFilter.getHtmlBuild()}
                        </div>
                        -->

                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.topPerformingArticleDeviceFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            <label class="form-label" for="" >Premium</label>
                            ${this.topPerformingArticlePremiumFilter.getHtmlBuild()}
                        </div>
                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.topPerformingArticlePostContentTypesFilter.getHtmlBuild()}
                        </div>

                        <div class="dropdown select-single" data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            <label class="form-label" for="">Page Type</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: articleTypeSelectedText"></button>
                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: articleTypes">
                                        <input type="radio" data-bind="checked : $parent.articleTypeSelected, value: id,  attr: { 'id': 'article_type_' + id, 'name' : 'article_type_' + id }, event:{ change: $parent.onArticleTypeChange}">
                                        <label class="form-label" data-bind="attr: {for : 'article_type_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.networkCategoriesFilter.getHtmlBuild()}
                        </div>


                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.postPaymentCategorySystemFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            <label class="form-label" for="" ></label>
                            ${this.topPerformingArticlePrimaryCategoriesFilter.getHtmlBuild()}
                        </div>
                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                        ${this.topPerformingArticlePrimaryTagsFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.tagsFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.tagTypesFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.srEditorsFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.jrEditorsFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.authorsFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.ideatorsFilter.getHtmlBuild()}
                        </div>
 
                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            <label class="form-label" for="" >Results</label>
                            ${this.topPerformingArticleReportLimitFilter.getHtmlBuild()}
                        </div>
                        
                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.dateFilter.getHtmlBuild()}
                        </div>

                        <div data-bind="visible: viewModeSelected() != 'topPerformingArticles'">
                            ${this.datesFilter.getHtmlBuild()}
                        </div>
                        
          
                        <div class="dropdown select-single" data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            <label class="form-label" for="">Publishing type</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: publishStatusSelectedText"></button>

                            <div class="dropdown-list">
                                <div class="w-form">
                                    <div class="form-group" data-bind="foreach: publishStatus">
                                        <input type="radio" data-bind="checked : $parent.publishStatusSelected, value: id,  attr: { 'id': 'pub_status_' + id, 'name' : 'pub_status_' + id }, event:{ change: $parent.onPublishStatusChange}">
                                        <label class="form-label" data-bind="attr: {for : 'pub_status_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="content-form-radio">
                            <div class="title" style="font-family:Lato, sans-serif" data-bind="visible: viewModeSelected() == 'topPerformingArticles'">Form</div>
                            <form >
                                <div style="display: flex; gap:0.5rem" data-bind="foreach: formOptions">
                                <input type="radio" data-bind="checked : $parent.formOptionSelected, value: id,  attr: { 'id': 'form_' + id, 'name' : 'form_' + id }, event:{ change: $parent.onFormOptionChange}">
                                <label class="form-label" data-bind="attr: {for : 'form_' + id }, text: name"></label>
                                </div>
                            </form>
                        </div> 
                        <div data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                            ${this.brandSafetyFilter.getHtmlBuild()}
                        </div>
                    </div> 
                </div>

                ${this.validationsList.getHtmlBuild()  }

                 <div class="w-filters-selected">
                    <div id="filters-selected" class="filters-selected">
                       <div id="selected-brand-segments"></div>
                       <div id="selected-initiatives"></div>
                       <div id="selected-systems"></div>
                       <div id="selected-intents"></div>
                       <div id="selected-content_types"></div>
                       <div id="selected-network_categories"></div>
                       <div id="selected-primary_categories"></div>
                       <div id="selected-primary_tags"></div>
                       <div id="selected-tags"></div>
                       <div id="selected-tag_types"></div>
                       <div id="selected-sr_editors"></div>
                       <div id="selected-jr_editors"></div>
                       <div id="selected-writers"></div>
                       <div id="selected-ideators"></div>
                       <div id="selected-brands"></div>
                       <div id="selected-devices"></div>
                       <div id="selected-tags"></div>
                       <div id="selected-tag_types"></div>
                       <div id="selected-brandSafety"></div>
                    </div>
                </div>

                <div id="content-wrapper">

                    <!--
                    <div class="w-page-tab">
                        <div class="page-tab">
                            <button class="btn large icon i-roi text-transform-none" data-bind="event: { click: onViewModeChange.bind($data, 'articleSv')}, css: {'active': viewModeSelected() == 'articleSv'} ">Active SV</button>
                            <button class="btn large icon i-roi text-transform-none" data-bind="event: { click: onViewModeChange.bind($data, 'topPerformingArticles')}, css: {'active': viewModeSelected() == 'topPerformingArticles'}">Top Performing Articles</button>
                        </div>
                    </div>
                    -->
                    
                    <!-- Article SV section  -->
                    <div id="articleSv" data-bind="visible: viewModeSelected() == 'articleSv'">
                        <div class="list-header w-justify" style="align-items: flex-end;">
                            <div class="w-left">
                                <h2 class="section-title icon i-roi">Article SV</h2>
                                <ul class="tooltip-tag-view">
                                    <li>
                                        The SV Report currently captures 99% of all revenue passing through GA4 and 90-95 of all display revenue.<br/>
                                        <span class="article-sv-bold">This represents about 55-70% of total revenue.</span> (Gaps are largely due to the absence of Video and Affiliate revenue).
                                    </li>
                                </ul>
                            </div>

                            <div class="w-center">
                                ${this.keywordFilter.getHtmlBuild()}
                            </div>

                            <div class="w-right">
                                ${this.pagination.getHtmlBuild()}
                                <button class="btn icon highlight i-export" type="button" data-bind="event: {click: onExportData}">Export</button>
                            </div>
                        </div>

                        <div class="w-list-results" style="padding-bottom: 200px">
                            <table class="list-results list-sections thin">

                                <thead>
                                    ${this.headers.getHtmlBuild()  }
                                </thead>

                                <tbody data-bind="foreach: tableData">
                                    <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">

                                        <td>
                                                <a data-bind="attr: {href: permalink}" target="_blank">
                                                    <span class="truncate" style="max-width: 20rem" data-bind="text: title"></span>
                                                    <i class="icon i-ext-link"></i>
                                                </a>
                                        </td>

                                        <td class="colgroup-1 start"><span data-bind="text: Number(revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                        <td class="colgroup-1"><span data-bind="text: Number(sessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                        <td class="colgroup-1"><span data-bind="text: Number(sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                        <td class="colgroup-1 end"><span data-bind="text: Number(pageviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                        <td class="colgroup-2"><span data-bind="text: Number(rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                        <td class="colgroup-2 end"><span class="no-wrap" data-bind="text: initiativeName"></span></td>
                                        <td class="colgroup-3"><span class="no-wrap" data-bind="text: intentName"></span></td>
                                        <td class="colgroup-3"><span class="no-wrap" data-bind="text: contentTypeName"></span></td>
                                        <td class="colgroup-3"><span class="no-wrap" data-bind="text: networkCategoryName"></span></td>
                                        <td class="colgroup-4"><span class="no-wrap" data-bind="text: primaryCategoryName"></span></td>
                                        <td class="colgroup-4"><span class="no-wrap" data-bind="text: primaryTagName"></span></td>
                                        <td class="colgroup-4"></td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                    <!-- End Article SV section  -->
                    
                

                    <!-- Top Performing Articles section  -->
                    <div id="topPerformingArticles" class="containerTopPerformingArticles" data-bind="visible: viewModeSelected() == 'topPerformingArticles'">
                        <div class="list-header w-justify" style="align-items: flex-end;    align-items: flex-end;
                    }">
                            <div class="w-left">
                                <h2 class="section-title icon i-roi">Audience Value Tool</h2>
                            </div>

                            <div class="w-center">
                                ${this.keywordFilter.getHtmlBuild()}
                            </div>

                            <div class="w-right">
                            <label class="toggle">
                                        <span class="toggle-label" data-bind="css: (audienceValueDataSource() === 'ch') ? 'is-activated' : ''">CH</span>
                                        <input class="toggle-checkbox" data-bind="event: {change: onToggleAudienceValueDataSource}, checked: (audienceValueDataSource() === 'mysql')" type="checkbox">
                                        <div class="toggle-switch"></div>
                                        <span class="toggle-label" data-bind="css: (audienceValueDataSource() === 'mysql') ? 'is-activated' : ''">MySQL</span>
                                    </label>
                                <!-- ${this.pagination.getHtmlBuild()} -->
                                <button class="btn icon highlight i-export" type="button" data-bind="event: {click: onExportData}">Export</button>
                            </div>
                        </div>

                        <div class="w-list-results" style="padding-bottom: 200px">
                            <table class="list-results list-sections thin content_rpm_tool">
                            ${this.resultsInfo.getHtmlBuild()}
                            

                                ${this.articlePerformanceHeaders.getHtmlBuild()}

                                <tbody>
                                
                                    <!-- ko foreach: topPerformingArticlesTableData -->
                                    <tr class="not-total" data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                                        <td>
                                            <span class="no-wrap" data-bind="text: brandName"></span>
                                        </td>
                                        <td class="article-sv-name"> 
                                            <!-- ko if: isPremium == 1 -->
                                                <i title="Premium Content" class="icon i-star-full"></i>
                                            <!-- /ko -->                                         
                                            <a data-bind="attr: {href: fullPageUrl, title: fullPageUrl}" target="_blank">
                                                <span data-bind="text: ((permalink == '/') ? fullPageUrl : ((subdomain !== null && subdomain !== '') ? subdomain + '  ...  ' + permalink : permalink))">
                                                <i class="icon i-ext-link"></i>      
                                            </a>
                                        </td>
                                        <td class="colgroup-1 start">
                                            <span data-bind="text: formattedDate, attr: {title: dateLastPublishStatus}">
                                        </td>
                                        <td class="colgroup-1">
                                            <span style="cursor: pointer;" data-bind="text: primaryCategoryName, event: { click: $parent.onClickCategory }, attr: {title: primaryCategoryName}">
                                        </td>
                                        <td class="colgroup-1">
                                            <span style="cursor: pointer;" data-bind="text: primaryTagName, event: { click: $parent.onClickTag }, attr: {title: primaryTagName}">
                                        </td>
                                        <td class="colgroup-1">
                                            <span data-bind="text: contentTypeGroup">
                                        </td>
                                        <td class="colgroup-1 end">
                                            <span data-bind="text: brandSafeCheck">
                                        </td>
                                        <td class="colgroup-2">
                                            <span data-bind="text: '$' + Number(sessionValue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})">
                                        </td>
                                        <td class="colgroup-2 end">
                                            <span data-bind="text: '$' + Number(revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                        </td>
                                        <td class="colgroup-3">
                                            <span data-bind="text: Number(views).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                        </td>
                                        <td class="colgroup-3">
                                        <span data-bind="text: Number(impressionsPageView).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})">
                                        </td>
                                        <td class="colgroup-3">
                                        <span data-bind="text: Number(requestsPageView).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})">
                                        </td>
                                        <td class="colgroup-3">
                                        <span data-bind="text: Number(cpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                        </td>
                                        <td class="colgroup-3">
                                        <span data-bind="text: Number(impressionsRequest).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'">
                                        </td>
                                        <td class="colgroup-3">
                                        <span data-bind="text: Number(usPageViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                        
                                        </td>
                                        <td class="colgroup-3">
                                        <span data-bind="text: Number(nonUsPageViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                        
                                        </td>
                                        <td class="colgroup-3">
                                        <span data-bind="text: Number(chromeViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                        
                                        </td>
                                        <td class="colgroup-3">
                                            <span data-bind="text: Number(recirculation).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                        </td>
                                        <td class="colgroup-3">
                                            <span data-bind="text: Number(viewAvgEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'">
                                        </td>
                                        <td class="colgroup-3">
                                            <span data-bind="text: viewAvgEngagedMinutesSeconds">
                                        </td>
                                        <td class="colgroup-3">
                                        <span data-bind="text: Number(articleLimitDismissRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                        </td>
                                        
                                    </tr>
                                    <!-- /ko -->


                                    <!-- ko foreach: topPerformingArticlesTableDataTotals -->
                                    <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                                        <td colspan="2">
                                            <span class="no-wrap">TOTAL</span>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                            <span data-bind="text: '$' + Number(sessionValue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})">
                                        </td>
                                        <td>
                                            <span data-bind="text: '$' + Number(revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                        </td>
                                        <td>
                                            <span data-bind="text: Number(views).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                        </td>
                                        <td>
                                        <span data-bind="text: Number(impressionsPageView).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})">
                                        </td>
                                        <td>
                                        <span data-bind="text: Number(requestsPageView).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})">
                                        </td>
                                        <td>
                                        <span data-bind="text: Number(cpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                        </td>
                                        <td>
                                        <span data-bind="text: Number(impressionsRequest).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'">
                                        </td>
                                        <td>
                                        <span data-bind="text: Number(usPageViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                        
                                        </td>
                                        <td>
                                        <span data-bind="text: Number(nonUsPageViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                        </td>
                                        <td>
                                        <span data-bind="text: Number(chromeViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                        </td>
                                        <td>
                                            <span data-bind="text: Number(recirculation).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                        </td>
                                        <td>
                                            <span data-bind="text: Number(viewAvgEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                        </td>
                                        <td>
                                            <span data-bind="text: viewAvgEngagedMinutesSeconds"></span>
                                        </td>
                                        <td>
                                            <span data-bind="text: Number(articleLimitDismissRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                        </td>
                                        
                                    </tr>
                                    <!-- /ko -->
                                    

                                </tbody>

                            </table>
                        </div> 

                    </div>
                    <!-- End Top Performing Articles section  -->
                </div>
            `;
    }

    protected initPartial():void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('articleRevenue');

        this.brandsFilter = new filterDropdown_template("brandsFilter", this.getTemplateViewModel(), this.caller);

        this.topPerformingArticleBrandSegmentsFilter = new multipleSelector_template("topPerformingArticleBrandSegmentsFilter", this.getTemplateViewModel(), this.caller);
        this.topPerformingArticleBrandSegmentsFilter.setTagContainerId('selected-brand-segments');
        this.topPerformingArticleBrandSegmentsFilter.setTagContainerCaption('Selected segments:');
        this.topPerformingArticleBrandSegmentsFilter.setLabel("segments");
        this.topPerformingArticleBrandSegmentsFilter.setLogoEnabled(false);

        this.postInitiativesFilter = new multipleSelector_template("postInitiativesFilter", this.getTemplateViewModel(), this.caller);
        this.postInitiativesFilter.setLabel("Mappings");
        this.postInitiativesFilter.setFilterContainerClass('margin-neg');
        this.postInitiativesFilter.setTagContainerId('selected-initiatives');
        this.postInitiativesFilter.setTagContainerCaption('Selected mappings:');

        this.postPaymentCategorySystemFilter = new multipleSelector_template("postPaymentCategorySystemFilter", this.getTemplateViewModel(), this.caller);
        this.postPaymentCategorySystemFilter.setLabel("System");
        this.postPaymentCategorySystemFilter.setFilterContainerClass('margin-neg');
        this.postPaymentCategorySystemFilter.setTagContainerId('selected-systems');
        this.postPaymentCategorySystemFilter.setTagContainerCaption('Selected systems:');

        this.postIntentsFilter = new multipleSelector_template("postIntentsFilter", this.getTemplateViewModel(), this.caller);
        this.postIntentsFilter.setLabel("Intents");
        this.postIntentsFilter.setFilterContainerClass('margin-neg');
        this.postIntentsFilter.setTagContainerId('selected-intents');
        this.postIntentsFilter.setTagContainerCaption('Selected intents:');

        this.postContentTypesFilter = new multipleSelector_template("postContentTypesFilter", this.getTemplateViewModel(), this.caller);
        this.postContentTypesFilter.setLabel("content types");
        this.postContentTypesFilter.setTagContainerId('selected-content_types');
        this.postContentTypesFilter.setTagContainerCaption('Selected content types:');

        this.networkCategoriesFilter = new multipleSelector_template("networkCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoriesFilter.setLabel("network categories");
        this.networkCategoriesFilter.setTagContainerId('selected-network_categories');
        this.networkCategoriesFilter.setTagContainerCaption('Selected network categories:');

        this.primaryCategoriesFilter = new filterMultipleAutoComplete_template("primaryCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.primaryCategoriesFilter.setIsVisible(1);
        this.primaryCategoriesFilter.setPlaceHolderText("Primary Category");
        this.primaryCategoriesFilter.setIcon("i-tag-a");
        this.primaryCategoriesFilter.setTagContainerId('selected-primary_categories');
        this.primaryCategoriesFilter.setTagContainerCaption('Selected Primary Categories:');
        this.primaryCategoriesFilter.setMinInputSuggestionLength(2);

        this.primaryTagsFilter = new filterMultipleAutoComplete_template("primaryTagsFilter", this.getTemplateViewModel(), this.caller);
        this.primaryTagsFilter.setIsVisible(1);
        this.primaryTagsFilter.setPlaceHolderText("Primary Tag");
        this.primaryTagsFilter.setIcon("i-tag-a");
        this.primaryTagsFilter.setTagContainerId('selected-primary_tags');
        this.primaryTagsFilter.setTagContainerCaption('Selected Primary Tags:');
        this.primaryTagsFilter.setMinInputSuggestionLength(2);

        this.tagTypesFilter = new filterMultipleAutoComplete_template("tagTypesFilter", this.getTemplateViewModel(), this.caller);
        this.tagTypesFilter.setIsVisible(1);
        this.tagTypesFilter.setPlaceHolderText("Tag Types");
        this.tagTypesFilter.setIcon("i-tag-a");
        this.tagTypesFilter.setTagContainerId('selected-tag_types');
        this.tagTypesFilter.setTagContainerCaption('Selected Tag Types:');
        this.tagTypesFilter.setMinInputSuggestionLength(2);

        this.srEditorsFilter = new filterMultipleAutoComplete_template("srEditorsFilter", this.getTemplateViewModel(), this.caller);
        this.srEditorsFilter.setIsVisible(1);
        this.srEditorsFilter.setPlaceHolderText("Sr Editor");
        this.srEditorsFilter.setIcon("i-user2");
        this.srEditorsFilter.setTagContainerId('selected-sr_editors');
        this.srEditorsFilter.setTagContainerCaption('Selected Sr Editors:');
        this.srEditorsFilter.setMinInputSuggestionLength(2);

        this.jrEditorsFilter = new filterMultipleAutoComplete_template("jrEditorsFilter", this.getTemplateViewModel(), this.caller);
        this.jrEditorsFilter.setIsVisible(1);
        this.jrEditorsFilter.setPlaceHolderText("Jr Editor");
        this.jrEditorsFilter.setIcon("i-user2");
        this.jrEditorsFilter.setTagContainerId('selected-jr_editors');
        this.jrEditorsFilter.setTagContainerCaption('Selected Jr Editors:');
        this.jrEditorsFilter.setMinInputSuggestionLength(2);

        this.authorsFilter = new filterMultipleAutoComplete_template("authorsFilter", this.getTemplateViewModel(), this.caller);
        this.authorsFilter.setIsVisible(1);
        this.authorsFilter.setPlaceHolderText("Writer");
        this.authorsFilter.setIcon("i-user2");
        this.authorsFilter.setTagContainerId('selected-writers');
        this.authorsFilter.setTagContainerCaption('Selected Writers:');
        this.authorsFilter.setMinInputSuggestionLength(2);

        this.ideatorsFilter = new filterMultipleAutoComplete_template("ideatorsFilter", this.getTemplateViewModel(), this.caller);
        this.ideatorsFilter.setIsVisible(1);
        this.ideatorsFilter.setPlaceHolderText("Ideator");
        this.ideatorsFilter.setIcon("i-user2");
        this.ideatorsFilter.setTagContainerId('selected-ideators');
        this.ideatorsFilter.setTagContainerCaption('Selected Ideators:');
        this.ideatorsFilter.setMinInputSuggestionLength(2);

        this.brandSafetyFilter = new multipleSelector_template("brandSafetyFilter", this.getTemplateViewModel(), this.caller);
        this.brandSafetyFilter.setLabel("Brand Safety");
        this.brandSafetyFilter.setFilterContainerClass('margin-neg');
        this.brandSafetyFilter.setTagContainerId('selected-brandSafety');
        this.brandSafetyFilter.setTagContainerCaption('Selected brand safety:');

        let defaultDates = this.getDefaultDates();

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);
        this.datesFilter.setDateRange(defaultDates[0], defaultDates[1]);

        let defaultDate = this.getDefaultDate(-1);
        // this.dateFilter = new filterSingleDate_template( "dateFilter", this.getTemplateViewModel(), this.caller );
        // this.dateFilter.setDate(defaultDate);

        this.keywordFilter = new filterSimple_template("keywordFilter",this.getTemplateViewModel(),this.caller);
        this.keywordFilter.setSearchableFields(['article title']);

        this.resultsInfo = new resultsInfo_template("resultsInfo", this.getTemplateViewModel(), this.caller);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);


        let headers = [
            {headerName: "Article", fieldName: "title", subHeaders: []},
            {headerName: "Revenue", fieldName: "revenue", subHeaders: []},
            {headerName: "Sessions", fieldName: "sessions", subHeaders: []},
            {headerName: "SV", fieldName: "sv", subHeaders: []},
            {headerName: "pageviews", fieldName: "pageviews", subHeaders: []},
            {headerName: "RPM", fieldName: "rpm", subHeaders: []},
            {headerName: "Initiative", fieldName: "initiativeName", subHeaders: []},
            {headerName: "Intent", fieldName: "intentName", subHeaders: []},
            {headerName: "Content Type", fieldName: "contentTypeName", subHeaders: []},
            {headerName: "Network Categories", fieldName: "networkCategoryName", subHeaders: []},
            {headerName: "Primary Category", fieldName: "primaryCategoryName", subHeaders: []},
            {headerName: "Primary Tag", fieldName: "primaryTagName", subHeaders: []},
        ];

        this.headers = new simpleListHeader_template("listHeader", this.getTemplateViewModel(), this.caller, headers);
        this.headers.getTemplateViewModel().orderBy("sessions");
        this.headers.getTemplateViewModel().orderByDirection("DESC");
        this.headers.getTemplateViewModel().orderByAndDirection("sessions_DESC");


        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;

        this.exportDataCsv = new exportDataCsv();


        let topPerformingArticlesHeaders = [
            {headerName: "Brand", fieldName: "brandName", subHeaders: []},
            {headerName: "Article", fieldName: "fullPageUrl", subHeaders: []},
            {headerName: "Latest Pub.Date", fieldName: "dateLastPublishStatus", thClass: "colgroup-1 start",subHeaders: []},
            {headerName: "Cat", fieldName: "primaryCategoryName", thClass: "colgroup-1", subHeaders: []},
            {headerName: "Tag", fieldName: "primaryTagName", thClass: "colgroup-1", subHeaders: []},
            {headerName: "Form", fieldName: "contentTypeGroup", thClass: "colgroup-1", subHeaders: []},
            {headerName: "Brand Safe Check", fieldName: "brandSafeCheck", thClass: "colgroup-1 end", subHeaders: []},
            {headerName: "Page RPM", fieldName: "sessionValue", thClass: "colgroup-2", subHeaders: []},
            {headerName: "Revenue", fieldName: "revenue", thClass: "colgroup-2 end", subHeaders: []},
            {headerName: "Views", fieldName: "views", thClass: "colgroup-3", subHeaders: []},
            {headerName: "Imp/View", fieldName: "impressionsPageView", thClass: "colgroup-3", subHeaders: []},
            {headerName: "Req/View", fieldName: "requestsPageView", thClass: "colgroup-3", subHeaders: []},
            {headerName: "CPM", fieldName: "cpm", thClass: "colgroup-3", subHeaders: []},
            {headerName: "Fill Rate", fieldName: "impressionsRequest", thClass: "colgroup-3", subHeaders: []},
            {headerName: "Us", fieldName: "usPageViewsRatio", thClass: "colgroup-3", subHeaders: []},
            {headerName: "Non-US Prime", fieldName: "nonUsPageViewsRatio", thClass: "colgroup-3", description: "<p>Includes:</p> <div class='country-list'><span class='country'>AE</span><span class='country'>AT</span><span class='country'>AU</span><span class='country'>BD</span><span class='country'>BE</span><span class='country'>CA</span><span class='country'>CH</span><span class='country'>DE</span><span class='country'>DK</span><span class='country'>EG</span><span class='country'>ES</span><span class='country'>FI</span><span class='country'>FR</span><span class='country'>GB</span><span class='country'>HK</span><span class='country'>HU</span><span class='country'>ID</span><span class='country'>IE</span><span class='country'>IT</span><span class='country'>JP</span><span class='country'>KR</span><span class='country'>LU</span><span class='country'>MX</span><span class='country'>NL</span><span class='country'>NZ</span><span class='country'>QA</span><span class='country'>SA</span><span class='country'>SE</span><span class='country'>SG</span><span class='country'>TR</span></div>" ,subHeaders: []},
            {headerName: "Chrome", fieldName: "chromeViewsRatio", thClass: "colgroup-3", subHeaders: []},
            {headerName: "Recirc.", fieldName: "recirculation", thClass: "colgroup-3", subHeaders: []},
            {headerName: "Engaged", fieldName: "viewAvgEngagedDepthPercentage", thClass: "colgroup-3", subHeaders: []},
            {headerName: "AVD", fieldName: "viewAvgEngagedSeconds", thClass: "colgroup-3", subHeaders: []},
            {headerName: "Art. Limit Dismiss %", fieldName: "articleLimitDismissRatio", thClass: "colgroup-3",description: "<p>The percentage of article login limit events that resulted in a dismiss.</br>Calculated as: (Dismissals / Total Limit Events) on a given URL.</p>", subHeaders: []},
        ];

        this.articlePerformanceHeaders = new simpleListHeader_template('listTopPerformingArticlesHeader', this.getTemplateViewModel(), this.caller, topPerformingArticlesHeaders);
        this.articlePerformanceHeaders.getTemplateViewModel().orderBy("views");
        this.articlePerformanceHeaders.getTemplateViewModel().orderByDirection("DESC");
        this.articlePerformanceHeaders.getTemplateViewModel().orderByAndDirection("views_DESC");

        this.topPerformingArticleBrandsFilter = new multipleSelector_template('topPerformingArticleBrandsFilter', this.getTemplateViewModel(), this.caller);
        this.topPerformingArticleBrandsFilter.setLabel('Brands');
        this.topPerformingArticleBrandsFilter.setTagContainerId('selected-brands');
        this.topPerformingArticleBrandsFilter.setTagContainerCaption('Selected brands:');
        this.topPerformingArticleBrandsFilter.setLogoEnabled(true);

        this.countriesFilter = new filterDropdown_template("countriesFilter", this.getTemplateViewModel(), this.caller);
        this.countriesFilter.setLabel('Countries');

        this.topPerformingArticleDeviceFilter = new multipleSelector_template("topPerformingArticleDeviceFilter", this.getTemplateViewModel(), this.caller);
        this.topPerformingArticleDeviceFilter.setLabel('Devices');
        this.topPerformingArticleDeviceFilter.setTagContainerId('selected-devices');
        this.topPerformingArticleDeviceFilter.setTagContainerCaption('Selected Devices:');

        this.topPerformingArticlePrimaryCategoriesFilter = new filterMultipleAutoComplete_template("topPerformingArticlePrimaryCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.topPerformingArticlePrimaryCategoriesFilter.setIsVisible(1);
        this.topPerformingArticlePrimaryCategoriesFilter.setPlaceHolderText("Primary Category");
        this.topPerformingArticlePrimaryCategoriesFilter.setIcon("i-tag-a");
        this.topPerformingArticlePrimaryCategoriesFilter.setTagContainerId('selected-primary_categories');
        this.topPerformingArticlePrimaryCategoriesFilter.setTagContainerCaption('Selected Primary Categories:');
        this.topPerformingArticlePrimaryCategoriesFilter.setMinInputSuggestionLength(2);

        this.topPerformingArticlePostContentTypesFilter = new multipleSelector_template("topPerformingArticlePostContentTypesFilter", this.getTemplateViewModel(), this.caller);
        this.topPerformingArticlePostContentTypesFilter.setLabel("content types");
        this.topPerformingArticlePostContentTypesFilter.setTagContainerId('selected-content_types');
        this.topPerformingArticlePostContentTypesFilter.setTagContainerCaption('Selected content types:');

        this.topPerformingArticlePrimaryTagsFilter = new filterMultipleAutoComplete_template("topPerformingArticlePrimaryTagsFilter", this.getTemplateViewModel(), this.caller);
        this.topPerformingArticlePrimaryTagsFilter.setIsVisible(1);
        this.topPerformingArticlePrimaryTagsFilter.setPlaceHolderText("Primary Tag");
        this.topPerformingArticlePrimaryTagsFilter.setIcon("i-tag-a");
        this.topPerformingArticlePrimaryTagsFilter.setTagContainerId('selected-primary_tags');
        this.topPerformingArticlePrimaryTagsFilter.setTagContainerCaption('Selected Primary Tags:');
        this.topPerformingArticlePrimaryTagsFilter.setMinInputSuggestionLength(2);

        this.tagsFilter = new filterMultipleAutoComplete_template("tagsFilter", this.getTemplateViewModel(), this.caller);
        this.tagsFilter.setIsVisible(1);
        this.tagsFilter.setPlaceHolderText("Tags");
        this.tagsFilter.setIcon("i-tag-a");
        this.tagsFilter.setTagContainerId('selected-tags');
        this.tagsFilter.setTagContainerCaption('Selected Tags:');
        this.tagsFilter.setMinInputSuggestionLength(2);

        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.setStartPickerId('startDatePicker');
        this.dateFilter.setEndPickerId('endDatePicker');
        this.dateFilter.setDateRange(defaultDates[0], defaultDates[1]);

        this.topPerformingArticlePremiumFilter = new filterDropdown_template("topPerformingArticlePremiumFilter", this.getTemplateViewModel(), this.caller);
        this.topPerformingArticleReportLimitFilter = new filterDropdown_template("topPerformingArticleReportLimitFilter", this.getTemplateViewModel(), this.caller);

    }

    protected getTemplateName(): string{

        return "articleRevenue_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }


    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            tableData                                  : ko.observableArray([]),
            exportData                                 : ko.observableArray([]),
            minSessions                                : ko.observable(null),
            publishStatus                              : ko.observableArray([]),
            publishStatusSelected                      : ko.observable(""),
            publishStatusSelectedText                  : ko.observable("all"),
            articleTypes                               : ko.observableArray([]),
            articleTypeSelected                        : ko.observable("all"),
            articleTypeSelectedText                    : ko.observable("All"),
            viewModeSelected                           : ko.observable("topPerformingArticles"),
            audienceValueDataSource                    : ko.observable("mysql"),
            topPerformingArticlesTableData             : ko.observableArray([]),
            topPerformingArticlesTableDataTotals       : ko.observable([]),
            topPerformingArticlesExportData            : ko.observableArray([]),
            disclaimer                                 : ko.observableArray([]),
            isCurrentDay                               : ko.observable(""),
            dateUpdated                                : ko.observable(""),
            formOptions                                : ko.observableArray([]),
            formOptionSelected                         : ko.observable("all"),
            selectedRows                                : ko.observableArray([]),
            onPublishStatusChange                      : function(data){ huit_neuf_this.onPublishStatusChange(data); },
            onArticleTypeChange                        : function(data){ huit_neuf_this.onArticleTypeChange(data); },
            onExportData                               : function(){ huit_neuf_this.onExportData(); },
            onMinSessionsChange: function () {
                huit_neuf_this.onMinSessionsChange();
            },
            onClearMinSessions: function (data, event) {
                huit_neuf_this.onClearMinSessions(event);
            },
            onViewModeChange: function(value, data, event) {
                huit_neuf_this.onViewModeChange(value, data, event);
            },
            onClickCategory: function(data) {
                huit_neuf_this.onClickCategory(data);
            },
            onClickTag: function(data) {
                huit_neuf_this.onClickTag(data);
            },
            onFormOptionChange: function(data) {
                huit_neuf_this.onFormOptionChange(data);
            },
            onToggleAudienceValueDataSource: function(data, event) {
                huit_neuf_this.onToggleAudienceValueDataSource(data, event);
            },
            onClickRowClick: function(index, data){
                huit_neuf_this.onClickRowClick(index);
                return true;
            }
        };
    }

    public getViewModelForRequest(){

        return {
            filter: {
                brand: this.brandsFilter.getTemplateViewModel().selectedOption(),
                postInitiatives: this.getTemplateViewModel().postInitiativesFilter.selectedItems(),
                postIntents: this.getTemplateViewModel().postIntentsFilter.selectedItems(),
                postContentTypes: this.getTemplateViewModel().postContentTypesFilter.selectedItems(),
                networkCategories: this.getTemplateViewModel().networkCategoriesFilter.selectedItems(),
                idPrimaryCategories: this.getTemplateViewModel().primaryCategoriesFilter.selectedItemIds(),
                namePrimaryCategories: this.getTemplateViewModel().primaryCategoriesFilter.selectedItemNames(),
                idPrimaryTags: this.getTemplateViewModel().primaryTagsFilter.selectedItemIds(),
                namePrimaryTags: this.getTemplateViewModel().primaryTagsFilter.selectedItemNames(),
                idTags: this.getTemplateViewModel().tagsFilter.selectedItemIds(),
                nameTags: this.getTemplateViewModel().tagsFilter.selectedItemNames(),
                idTagTypes: this.getTemplateViewModel().tagTypesFilter.idSelectedItem(),
                nameTagTypes: this.getTemplateViewModel().tagTypesFilter.nameSelectedItem(),
                srEditors: this.getTemplateViewModel().srEditorsFilter.selectedItemIds(),
                srEditorNames: this.getTemplateViewModel().srEditorsFilter.selectedItemNames(),
                jrEditors: this.getTemplateViewModel().jrEditorsFilter.selectedItemIds(),
                jrEditorNames: this.getTemplateViewModel().jrEditorsFilter.selectedItemNames(),
                authors: this.getTemplateViewModel().authorsFilter.selectedItemIds(),
                authorNames: this.getTemplateViewModel().authorsFilter.selectedItemNames(),
                ideators: this.getTemplateViewModel().ideatorsFilter.selectedItemIds(),
                ideatorNames: this.getTemplateViewModel().ideatorsFilter.selectedItemNames(),
                dateFilterType: this.getTemplateViewModel().datesFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                startDateRange: this.getTemplateViewModel().datesFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().datesFilter.toRange(),
                publishStatus: this.getTemplateViewModel().publishStatusSelected(),
                articleType: this.getTemplateViewModel().articleTypeSelected(),
                articleTypeSelectedText: this.getTemplateViewModel().articleTypeSelectedText(),
                minSessions: this.getTemplateViewModel().minSessions(),
                keyword: this.getTemplateViewModel().keywordFilter.filterKeyword(),
            },
            pagination: this.getTemplateViewModel().pagination,
            headers: this.headers.getViewModelForRequest(),
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        return super.build(classesToAdd);
    }

    //build the date Picker calendar
    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();

    }

    public setBrandFilterItems(brands) {

        this.brandsFilter.setOptions(brands);
        this.brandsFilter.setLabel("Brands");
    }

    public setPostPaymentCategorySystemFilterItems(items){

        for (let item of items){

            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no systems'});
        this.postPaymentCategorySystemFilter.setItems(items);
    }

    public setTopPerformingArticleBrandSegments(brandSegments){

        let groups = [];
        for (let brand of brandSegments){

            let segments = [];
            for( let segment of brand.segments){

                segments.push(segment);
            }

            let group = {"name" : brand.name, "items" : segments};
            groups.push(group);
        }
        this.topPerformingArticleBrandSegmentsFilter.setMultiSectionItems(groups);
        this.topPerformingArticleBrandSegmentsFilter.setLabel('Segments');
    }

    public setPostInitiativesFilterItems(items){
        for (let item of items){
            item['name'] = item['initiative'];
        }
        items.unshift({'id': 0, 'name' : 'no mappings'});
        this.postInitiativesFilter.setItems(items);
    }

    public setPostIntentsFilterItems(items){
        for (let item of items){
            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no intents'});
        this.postIntentsFilter.setItems(items);
    }

    public setPostContentTypesFilterItems(items){

        items.unshift({id: 0, name: 'no post types', contentTypes: [{id: 0, name: 'no post types'}]});

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.postContentTypesFilter.setMultiSectionItems(groups);
        this.postContentTypesFilter.setLabel('Content Types');
    }

    public setNetworkCategoriesFilterItems(items){

        items.unshift({id: 0, name: 'no network categories', networkCategories: [{id: 0, name: 'no network categories'}]});

        let groups = [];
        for (let groupedNetworkCategory of items){

            let group = {"name" : groupedNetworkCategory.name, "items" : groupedNetworkCategory.networkCategories};
            groups.push(group);
        }

        this.networkCategoriesFilter.setMultiSectionItems(groups);
        this.networkCategoriesFilter.setLabel('Network Categories');
    }

    public setCountriesFilterItems(items){

        this.countriesFilter.setOptions(items);
    }

    public setPrimaryCategoriesFilterItems(items){

        this.primaryCategoriesFilter.setItems(items);
    }

    public setPrimaryTagsFilterItems(items){

        this.primaryTagsFilter.setItems(items);
    }

    public setTagsFilterItems(items){

        this.tagsFilter.setItems(items);
    }

    public setTagTypesFilterItems(items){

        this.tagTypesFilter.setItems(items);
    }

    public setSrEditorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.srEditorsFilter.setItems(items);
    }

    public setJrEditorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.jrEditorsFilter.setItems(items);
    }

    public setAuthorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.authorsFilter.setItems(items);
    }

    public setIdeatorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.ideatorsFilter.setItems(items);
    }

    public setBrandSafetyFilterItems(){

        this.brandSafetyFilter.setItems(this.brandSafety);
    }

    public setPublishStatusItems(){
        this.getTemplateViewModel().publishStatus(this.publishStatus);
    }

    public setTopPerformingArticleArticleTypeFilterItems(){

        this.getTemplateViewModel().articleTypes(this.articleTypes);
    }

    public setTableData(tableData){

        this.getTemplateViewModel().tableData(tableData);
    }

    public onClickReorder(value, data, event){
        if(typeof data.orderBy === 'undefined'){
            data = this.getTemplateViewModel();
        }
        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection() === null || data.orderByAndDirection().includes(value)){
            if( data.orderByDirection() == "DESC" ){
                data.orderByDirection("ASC");
            }
            else{
                data.orderByDirection("DESC");
            }
        }
        else{
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listReorder();
    }

    private onPublishStatusChange(publishStatusSelected){

        this.getTemplateViewModel().publishStatusSelectedText(publishStatusSelected.name);
        this.caller.getListData();
    }

    private onArticleTypeChange(articleTypeSelected){

        this.getTemplateViewModel().articleTypeSelectedText(articleTypeSelected.name);
        this.caller.getListData();
    }

    /**
     * @inheritDoc
     */
    public setViewModelFromRequest(params : Array<any>): void{

        this.brandsFilter.getTemplateViewModel().selectedOption(params['filter']['brand']);
        this.presetFilter.setMultiSelectorPresetFilters(this.topPerformingArticleBrandSegmentsFilter, params['filter']['brandSegments']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postInitiativesFilter, params['filter']['postInitiatives']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postIntentsFilter, params['filter']['postIntents']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postContentTypesFilter, params['filter']['postContentTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.networkCategoriesFilter, params['filter']['networkCategories']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postPaymentCategorySystemFilter, params['filter']['postPaymentCategorySystems']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.primaryCategoriesFilter, params['filter']['idPrimaryCategories'], params['filter']['namePrimaryCategories']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.primaryTagsFilter, params['filter']['idPrimaryTags'], params['filter']['namePrimaryTags']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.topPerformingArticlePrimaryTagsFilter, params['filter']['idPrimaryTags'], params['filter']['namePrimaryTags']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.tagsFilter, params['filter']['idTags'], params['filter']['nameTags']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.tagTypesFilter, params['filter']['idTagTypes'], params['filter']['nameTagTypes']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.topPerformingArticlePrimaryCategoriesFilter, params['filter']['idPrimaryCategories'], params['filter']['namePrimaryCategories']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.srEditorsFilter, params['filter']['srEditors'], params['filter']['srEditorNames']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.jrEditorsFilter, params['filter']['jrEditors'], params['filter']['jrEditorNames']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.authorsFilter, params['filter']['authors'], params['filter']['authorNames']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.ideatorsFilter, params['filter']['ideators'], params['filter']['ideatorNames']);

        this.presetFilter.setMultiSelectorPresetFilters(this.topPerformingArticlePostContentTypesFilter, params['filter']['postContentTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.topPerformingArticleBrandsFilter, params['filter']['brands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.topPerformingArticleDeviceFilter, params['filter']['devices']);

        if(typeof params['filter']['brandSafetyTypes'] !== 'undefined'){

            this.presetFilter.setMultiSelectorPresetFilters(this.brandSafetyFilter, params['filter']['brandSafetyTypes']);
        }


        if (typeof params['filter']['postContentTypesGroup'] !== 'undefined') {

            this.getTemplateViewModel().formOptionSelected(params['filter']['postContentTypesGroup']);
        }

        if(typeof params['filter']['premium'] !== 'undefined'){

            this.topPerformingArticlePremiumFilter.setSelectedOption(params['filter']['premium']);
        }

        if(typeof params['filter']['reportLimit'] !== 'undefined'){

            this.topPerformingArticleReportLimitFilter.setSelectedOption(params['filter']['reportLimit']);
        }

        if(typeof params['filter']['dataSource'] !== 'undefined'){

            this.getTemplateViewModel().audienceValueDataSource(params['filter']['dataSource']);
        }

        this.presetFilter.setDates(this.dateFilter, params['filter']['dateFilterType'], params['filter']['startDate'], params['filter']['endDate'], params['filter']['startDateRange'], params['filter']['endDateRange']);


        // Publishing type custom filter
        if(typeof params['filter']['publishStatus'] !== 'undefined'){

            this.getTemplateViewModel().publishStatusSelected(params['filter']['publishStatus']);
            this.getTemplateViewModel().publishStatusSelectedText(this.presetFilter.getFilterTextFromId(this.publishStatus, params['filter']['publishStatus']));
        }

        if(typeof params['filter']['articleType'] !== 'undefined') {

            this.getTemplateViewModel().articleTypeSelected(params['filter']['articleType']);
            this.getTemplateViewModel().articleTypeSelectedText(this.presetFilter.getFilterTextFromId(this.articleTypes, params['filter']['articleType']));
        }

        if (typeof params['filter']['minSessions'] !== 'undefined') {

            this.getTemplateViewModel().minSessions(params['filter']['minSessions']);
        }

        if(typeof params['filter']['keyword'] !== 'undefined'){

            this.keywordFilter.getTemplateViewModel().filterKeyword(params['filter']['keyword'])
        }
    }

    public resetPageNumber(): void {

        this.pagination.getTemplateViewModel().pageNumber(1);
    }

    public setPaginationTotalCount(totalCount: number):  void {

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    private onMinSessionsChange() {

        this.resetPageNumber();
        this.caller.getListData();
    }

    protected onClearMinSessions(event) {

        this.getTemplateViewModel().minSessions(null);
        this.caller.getListData();
    }

    private onExportData(){

        this.caller.getExportData();
    }

    public setExportData(exportData){

        let exportDataView = [];
        for (let exportDataRow of exportData) {

            let exportDataViewRow = [];
            exportDataViewRow["Article"] = exportDataRow.title;
            exportDataViewRow["URL"] = exportDataRow.permalink;
            exportDataViewRow["Revenue"] = Number(exportDataRow.revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Sessions"] = Number(exportDataRow.sessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["SV"] = Number(exportDataRow.sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["pageviews"] = Number(exportDataRow.pageviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["RPM"] = Number(exportDataRow.rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Initiative"] = exportDataRow.initiativeName;
            exportDataViewRow["Intent"] = exportDataRow.intentName;
            exportDataViewRow["Content Type"] = exportDataRow.contentTypeName;
            exportDataViewRow["Network Categories"] = exportDataRow.networkCategoryName;
            exportDataViewRow["Primary Category"] = exportDataRow.primaryCategoryName;
            exportDataViewRow["Primary Tag"] = exportDataRow.primaryTagName;

            exportDataView.push(exportDataViewRow);
        }

        this.getTemplateViewModel().exportData(exportDataView);
    }

    public setResultInfo(nbResults, nbPages, execTime){

        this.resultsInfo.setExecutionTime(execTime);
        this.resultsInfo.setNbResults(nbResults);
        this.resultsInfo.setNbPages(nbPages);
    }

    private exportData(obj){

        if (this.getTemplateViewModel().viewModeSelected() == 'topPerformingArticles') {
            this.exportDataCsv.exportToCsv("TopPerformingArticles", this.getTemplateViewModel().topPerformingArticlesExportData());
        } else {
            this.exportDataCsv.exportToCsv("ArticleSV", this.getTemplateViewModel().exportData());
        }
    }

    private onViewModeChange(value, data, event) {

        this.getTemplateViewModel().viewModeSelected(value);

        let defaultDates = this.getDefaultDates();
        this.datesFilter.setDateRange(defaultDates[0], defaultDates[1]);


        this.dateFilter.setDateRange(defaultDates[0], defaultDates[1]);

        this.caller.getListFormData();
    }
    

    public setTopPerformingArticleBrands(departments) {
        let groups = [];
        for ( let department of departments){
            let group = {"name" : department.name, "items" : department.brands, "logo" : department.logo};
            groups.push(group);
        }
        this.topPerformingArticleBrandsFilter.setMultiSectionItems(groups);
    }

    public setDisclaimer(disclaimer) {

        this.getTemplateViewModel().disclaimer(disclaimer);
    }

    public setIsCurrentDay(isCurrentDay) {

        this.getTemplateViewModel().isCurrentDay(isCurrentDay);
    }

    public setDateUpdated(dateUpdated) {

        this.getTemplateViewModel().dateUpdated(dateUpdated);
    }

    public getViewModelForTopPerformingArticlesRequest(){

        return {
            filter: {
                dataSource: this.getTemplateViewModel().audienceValueDataSource(),
                pagination: this.getTemplateViewModel().pagination,
                brandSegments: this.getTemplateViewModel().topPerformingArticleBrandSegmentsFilter.selectedItems(),
                brands: this.getTemplateViewModel().topPerformingArticleBrandsFilter.selectedItems(),
                devices: this.getTemplateViewModel().topPerformingArticleDeviceFilter.selectedItems(),
                premium: this.getTemplateViewModel().topPerformingArticlePremiumFilter.selectedOption(),
                country: this.getTemplateViewModel().countriesFilter.selectedOption(),
                reportLimit: this.getTemplateViewModel().topPerformingArticleReportLimitFilter.selectedOption(),
                //date: this.dateFilter.getTemplateViewModel().singleDatePicker,
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                headers: this.articlePerformanceHeaders.getViewModelForRequest(),
                keyword: this.getTemplateViewModel().keywordFilter.filterKeyword(),
                postContentTypes: this.getTemplateViewModel().topPerformingArticlePostContentTypesFilter.selectedItems(),
                postInitiatives: this.getTemplateViewModel().postInitiativesFilter.selectedItems(),
                postPaymentCategorySystems: this.getTemplateViewModel().postPaymentCategorySystemFilter.selectedItems(),
                postContentTypesGroup: this.getTemplateViewModel().formOptionSelected(),
                articleType: this.getTemplateViewModel().articleTypeSelected(),
                articleTypeText: this.getTemplateViewModel().articleTypeSelectedText(),
                idPrimaryCategories: this.getTemplateViewModel().topPerformingArticlePrimaryCategoriesFilter.selectedItemIds(),
                namePrimaryCategories: this.getTemplateViewModel().topPerformingArticlePrimaryCategoriesFilter.selectedItemNames(),
                idPrimaryTags: this.getTemplateViewModel().topPerformingArticlePrimaryTagsFilter.selectedItemIds(),
                namePrimaryTags: this.getTemplateViewModel().topPerformingArticlePrimaryTagsFilter.selectedItemNames(),
                idTags: this.getTemplateViewModel().tagsFilter.selectedItemIds(),
                nameTags: this.getTemplateViewModel().tagsFilter.selectedItemNames(),
                idTagTypes: this.getTemplateViewModel().tagTypesFilter.selectedItemIds(),
                nameTagType: this.getTemplateViewModel().tagTypesFilter.selectedItemNames(),
                srEditors: this.getTemplateViewModel().srEditorsFilter.selectedItemIds(),
                srEditorNames: this.getTemplateViewModel().srEditorsFilter.selectedItemNames(),
                jrEditors: this.getTemplateViewModel().jrEditorsFilter.selectedItemIds(),
                jrEditorNames: this.getTemplateViewModel().jrEditorsFilter.selectedItemNames(),
                authors: this.getTemplateViewModel().authorsFilter.selectedItemIds(),
                authorNames: this.getTemplateViewModel().authorsFilter.selectedItemNames(),
                ideators: this.getTemplateViewModel().ideatorsFilter.selectedItemIds(),
                ideatorNames: this.getTemplateViewModel().ideatorsFilter.selectedItemNames(),
                brandSafetyTypes: this.getTemplateViewModel().brandSafetyFilter.selectedItems(),
                networkCategories: this.getTemplateViewModel().networkCategoriesFilter.selectedItems(),
                publishStatus: this.getTemplateViewModel().publishStatusSelected(),
                postIntents: this.getTemplateViewModel().postIntentsFilter.selectedItems(),
            }
        }
    }

    public setTopPerformingArticleTableData(tableData) {
        this.getTemplateViewModel().topPerformingArticlesTableData(tableData);
    }

    public setTopPerformingArticleTableDataTotals(totals) {
        this.getTemplateViewModel().topPerformingArticlesTableDataTotals(totals);
    }

    public setTopPerformingArticleDeviceFilterItems(devices) {
        this.topPerformingArticleDeviceFilter.setItems(devices);
    }

    public setTopPerformingArticlePremiumFilterItems(premiumOptions) {
        this.topPerformingArticlePremiumFilter.setOptions(premiumOptions);
        this.topPerformingArticlePremiumFilter.setLabel("Premium");
    }


    public setTopPerformingArticlePostContentTypesGroupFilterItems(contentTypesGroup) {

        this.getTemplateViewModel().formOptions(contentTypesGroup);
    }

    public setTopPerformingArticlePrimaryCategoriesFilterItems(items){
        this.topPerformingArticlePrimaryCategoriesFilter.setItems(items);
    }

    public setTopPerformingArticlePostContentTypesFilterItems(items){

        items.unshift({id: 0, name: 'no post types', contentTypes: [{id: 0, name: 'no post types'}]});

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.topPerformingArticlePostContentTypesFilter.setMultiSectionItems(groups);
        this.topPerformingArticlePostContentTypesFilter.setLabel('Content Types');
    }

    public setTopPerformingArticlePrimaryTagsFilterItems(items){

        this.topPerformingArticlePrimaryTagsFilter.setItems(items);
    }

    public setTopPerformingArticleReportLimitFilterItems(reportLimitOptions) {
        this.topPerformingArticleReportLimitFilter.setOptions(reportLimitOptions);
        //this.topPerformingArticlePremiumFilter.setLabel("Results");
    }

    public setTopPerformingArticleExportData(exportData, totals) {

        let exportDataView = [];

        for (let exportDataRow of exportData) {

            let exportDataViewRow = [];

            exportDataViewRow["Brand"] = exportDataRow.brandName;
            exportDataViewRow["isPremium"] = exportDataRow.isPremium;
            exportDataViewRow["Title"] = exportDataRow.articleTitle;
            exportDataViewRow["Full Page URL"] = exportDataRow.fullPageUrl;
            exportDataViewRow["Latest Pub. Date"] = exportDataRow.dateLastPublishStatus;
            exportDataViewRow["Primary Category"] = exportDataRow.primaryCategoryName;
            exportDataViewRow["Primary Tag"] = exportDataRow.primaryTagName;
            exportDataViewRow["Form"] = exportDataRow.contentTypeGroup;
            exportDataViewRow["Brand Safe Check"] = exportDataRow.brandSafeCheck;
            exportDataViewRow["Page RPM"] = "$" + Number(exportDataRow.sessionValue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Revenue"] = "$" + Number(exportDataRow.revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Views"] = Number(exportDataRow.views).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Imp/View"] = Number(exportDataRow.impressionsPageView).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Fill Rate"] = Number(exportDataRow.impressionsRequest).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";
            exportDataViewRow["Req/View"] = Number(exportDataRow.requestsPageView).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["CPM"] = Number(exportDataRow.cpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["US"] = Number(exportDataRow.usPageViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";
            exportDataViewRow["Non-US Prime"] = Number(exportDataRow.nonUsPageViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";
            exportDataViewRow["Chrome"] = Number(exportDataRow.chromeViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";
            exportDataViewRow["Recirculation"] = Number(exportDataRow.recirculation).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";
            exportDataViewRow["Engaged"] = Number(exportDataRow.viewAvgEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";
            exportDataViewRow["AVD"] = exportDataRow.viewAvgEngagedMinutesSeconds;
            exportDataViewRow["Art. Limit Dismiss %"] = Number(exportDataRow.articleLimitDismissRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";

            exportDataView.push(exportDataViewRow);
        }

        for (let exportDataRow of totals) {

            let exportDataViewRow = [];
            exportDataViewRow["Brand"] = "TOTAL";
            exportDataViewRow["isPremium"] = "";
            exportDataViewRow["Title"] = "";
            exportDataViewRow["Full Page URL"] = "";
            exportDataViewRow["Latest Pub. Date"] = "";
            exportDataViewRow["Primary Category"] = "";
            exportDataViewRow["Primary Tag"] = "";
            exportDataViewRow["Form"] = "";
            exportDataViewRow["Brand Safe Check"] = "";
            exportDataViewRow["Page RPM"] = "$" + Number(exportDataRow.sessionValue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Revenue"] = "$" + Number(exportDataRow.revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Views"] = Number(exportDataRow.views).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            exportDataViewRow["Imp/View"] = Number(exportDataRow.impressionsPageView).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["Fill Rate"] = Number(exportDataRow.impressionsRequest).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";
            exportDataViewRow["Req/View"] = Number(exportDataRow.requestsPageView).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["CPM"] = Number(exportDataRow.cpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            exportDataViewRow["US"] = Number(exportDataRow.usPageViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";
            exportDataViewRow["Non-US Prime"] = Number(exportDataRow.nonUsPageViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";
            exportDataViewRow["Chrome"] = Number(exportDataRow.chromeViewsRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";
            exportDataViewRow["Recirculation"] = Number(exportDataRow.recirculation).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";
            exportDataViewRow["Engaged"] = Number(exportDataRow.viewAvgEngagedDepthPercentage).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";
            exportDataViewRow["AVD"] = exportDataRow.viewAvgEngagedMinutesSeconds;
            exportDataViewRow["Art. Limit Dismiss %"] = Number(exportDataRow.articleLimitDismissRatio).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%";

            exportDataView.push(exportDataViewRow);
        }

        this.getTemplateViewModel().topPerformingArticlesExportData(exportDataView);
    }

    private getDefaultDates() {

        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfMonth = new Date(date.getFullYear(),date.getMonth(), 1);

        date.setDate(date.getDate() - 1);

        if(date.getTime() === firstOfMonth.getTime()) {
            // if it is the first day of the month, we display data from the last month
            firstOfMonth = new Date(date.getFullYear(),date.getMonth() - 1, 1);
        }

        if (this.getTemplateViewModel().viewModeSelected() == 'topPerformingArticles') {
            return [date, date];
        }

        return [firstOfMonth, date];
    }

    private getDefaultDate(diffDays: number) {

        let monthsList = [
            '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'
        ]
        let today = new Date();
        today.setDate(today.getDate() + diffDays);

        let day = '' + today.getDate();
        if (day.length < 2) {
            day = '0' + day;
        }

        return today.getFullYear() + '/' + monthsList[today.getMonth()] + '/' + day;
    }

    private onClickCategory(data) {

        this.presetFilter.setMultipleAutocompletePresetFilter(this.topPerformingArticlePrimaryCategoriesFilter, [data.idPrimaryCategory], [data.primaryCategoryName]);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.topPerformingArticlePrimaryTagsFilter, [], []);
        this.presetFilter.setMultiSelectorPresetFilters(this.topPerformingArticlePostContentTypesFilter, []);

        this.caller.getListData();
    }

    private onClickTag(data) {

        this.presetFilter.setMultipleAutocompletePresetFilter(this.topPerformingArticlePrimaryTagsFilter, [data.idPrimaryTag], [data.primaryTagName]);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.topPerformingArticlePrimaryCategoriesFilter, [], []);
        this.presetFilter.setMultiSelectorPresetFilters(this.topPerformingArticlePostContentTypesFilter, []);

        this.caller.getListData();
    }

    private onFormOptionChange(selectedRevenueOption){

        this.caller.getListData();
    }

    public onToggleAudienceValueDataSource(data, event) {

        let current = this.getTemplateViewModel().audienceValueDataSource();
        this.getTemplateViewModel().audienceValueDataSource(current === 'mysql' ? 'ch' : 'mysql');
        this.caller.getListData();
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/articleRevenue_template.ts